<template>
    <div class="consult-container" id="consult-section">
        <div class="consult-left">
            <div class="consult-info">
                <div class="main-title">立即咨询</div>
                <div class="sub-title">通过下方联系方式可以通过右侧填写信息，我们的顾问会尽快与您取得联系</div>
                <div class="divider"></div>
                <div class="contact-info">
                    <div class="contact-item">
                        <div class="label">公司座机</div>
                        <div class="value">0755-2942-2829</div>
                    </div>
                    <div class="contact-item">
                        <div class="label">咨询顾问</div>
                        <div class="value">137 1379 8717</div>
                    </div>
                </div>
                <div class="divider"></div>
            </div>
            <div class="consult-icons">
                <div class="icon-item">
                    <div class="icon-wrapper">
                        <img src="../assets/erweima1.png" alt="">
                    </div>
                    <div class="icon-text">伴生雾化技术咨询</div>
                </div>
                <!-- <div class="icon-item">
                    <div class="icon-wrapper">
                        <img src="../assets/home26.png" alt="">
                    </div>
                    <div class="icon-text">多种功能产品咨询</div>
                </div> -->
                <div class="icon-item" style="margin-left: 100px;">
                    <div class="icon-wrapper">
                        <img src="../assets/erweima2.png" alt="">

                    </div>
                    <div class="icon-text">代理服务分润咨询</div>
                </div>
                
            </div>
        </div>
        <div class="consult-right">
            <div class="form-item">
                <div class="form-label">姓名</div>
                <input 
                    v-model="form.name"
                    :style="{ width: inputWidth + 'px' }" 
                    type="text" 
                    placeholder="请输入您的名称"
                >
            </div>
            <div class="form-item">
                <div class="form-label">联系电话</div>
                <input 
                    v-model="form.phone"
                    :style="{ width: inputWidth + 'px' }" 
                    type="text" 
                    placeholder="请输入您的联系方式"
                >
            </div>
            <div class="form-item">
                <div class="form-label">需求咨询</div>
                <textarea 
                    v-model="form.content"
                    :style="{
                        width: inputWidth + 'px',
                        resize: 'none'
                    }" 
                    placeholder="请输入您的需求"
                ></textarea>
            </div>
            <div 
                :style="{ width: inputWidth + 'px' }" 
                class="submit-btn"
                @click="submitForm"
            >提交</div>
        </div>
        <div 
            v-if="showToast" 
            class="toast-message"
            :class="{ 'toast-success': toastType === 'success', 'toast-error': toastType === 'error' }"
        >
            {{ toastMessage }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConsultSection',
    data() {
        return {
            form: {
                name: '',
                phone: '',
                content: ''
            },
            showToast: false,
            toastMessage: '',
            toastType: 'success'
        }
    },
    props: {
        inputWidth: {
            type: [Number, String],
            default: 633
        }
    },
    methods: {
        showToastMessage(message, type = 'success') {
            this.toastMessage = message;
            this.toastType = type;
            this.showToast = true;
            setTimeout(() => {
                this.showToast = false;
            }, 3000);
        },
        async submitForm() {
            if (!this.form.name || !this.form.phone || !this.form.content) {
                this.showToastMessage('请填写完整信息', 'error');
                return;
            }

            try {
                const response = await fetch('https://open.feishu.cn/open-apis/bot/v2/hook/2d2280d9-8b92-4308-aa8c-bf19f50d7aff', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        msg_type: 'text',
                        content: {
                            text: `新的咨询信息:\n姓名: ${this.form.name}\n电话: ${this.form.phone}\n需求: ${this.form.content}`
                        }
                    })
                });

                if (response.ok) {
                    this.showToastMessage('提交成功');
                    this.form.name = '';
                    this.form.phone = '';
                    this.form.content = '';
                } else {
                    throw new Error('提交失败');
                }
            } catch (error) {
                this.showToastMessage('提交失败，请稍后重试', 'error');
                console.error(error);
            }
        }
    }
}
</script>

<style scoped>
.consult-container {
    display: flex;
    width: 1460px;
    margin: 0 auto;
    padding: 0 0 100px 0;
}

.consult-left {
    padding: 0 0 0 60px;
}

.main-title {
    font-size: 40px;
    color: #000000;
    font-weight: bold;
    padding: 89px 0 0 0;
}

.sub-title {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 400;
}

.divider {
    width: 640px;
    height: 1px;
    border: 1px solid #979797;
    opacity: 0.13;
    margin: 47px 0 0 0;
}

.contact-info {
    padding: 47px 0 0 0;
    display: flex;
    width: 640px;
}

.contact-item {
    padding: 0 108px 0 0;
}

.label {
    color: rgba(0, 0, 0, 0.5);
    font-size: 14px;
    font-weight: 400;
}

.value {
    font-weight: bold;
    font-size: 18px;
    color: #041214;
}

.consult-icons {
    display: flex;
    padding: 35px 0 0 0;
}

.icon-item {
    padding: 0 40px 0 0;
}

.icon-wrapper {
    width: 96px;
    height: 96px;
    margin: 12px auto;
}

.icon-text {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    font-style: normal;
}

.consult-right {
    padding: 101px 0 0 64px;
}

.form-item {
    margin-bottom: 31px;
}

.form-label {
    font-size: 16px;
    color: #000000;
    font-weight: 500;
    margin-bottom: 12px;
}

input,
textarea {
    border: none;
    text-indent: 16px;
    outline: none;
    background: #F5F6F7;
    border-radius: 8px;
    width: 633px;
}

input {
    height: 48px;
}

textarea {
    height: 112px;
    padding: 16px 0 0 0;
}

.submit-btn {
    width: 633px;
    background: #B80708;
    border-radius: 8px;
    height: 56px;
    font-size: 17px;
    color: #FFFFFF;
    font-weight: 600;
    line-height: 56px;
    text-align: center;
    cursor: pointer;
    margin: 31px 0 0 0;
}

/* 移动端适配样式 */
@media screen and (max-width: 768px) {
    .consult-container {
        flex-direction: column;
        width: 100%;
        padding: 0 15px 50px;
    }

    .consult-left {
        padding: 0;
    }

    .main-title {
        font-size: 28px;
        padding: 40px 0 0 0;
    }

    .sub-title {
        font-size: 14px;
        line-height: 1.5;
    }

    .divider {
        width: 100%;
        margin: 25px 0;
    }

    .contact-info {
        width: 100%;
        flex-direction: column;
        padding: 25px 0 0 0;
    }

    .contact-item {
        padding: 0 0 20px 0;
    }

    .consult-icons {
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 20px 0;
    }

    .icon-item {
        width: 33.33%;
        padding: 0;
        margin-bottom: 20px;
    }


    .icon-text {
        font-size: 14px;
        text-align: center;
    }

    .consult-right {
        padding: 30px 0 0 0;
    }

    .form-item {
        margin-bottom: 20px;
    }

    input,
    textarea {
        width: 100%;
    }

    .submit-btn {
        width: 100%;
        margin: 20px 0 0 0;
    }

    input,
    textarea,
    .submit-btn {
        width: 100% !important;
        max-width: 100% !important;
    }

    input[style],
    textarea[style],
    .submit-btn[style] {
        width: 100% !important;
        max-width: 100% !important;
    }
}

.toast-message {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    padding: 15px 30px;
    border-radius: 4px;
    font-size: 16px;
    z-index: 1000;
    animation: fadeIn 0.3s ease;
}

.toast-success {
    background-color: #f0f9eb;
    color: #67c23a;
    border: 1px solid #c2e7b0;
}

.toast-error {
    background-color: #fef0f0;
    color: #f56c6c;
    border: 1px solid #fbc4c4;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translate(-50%, -20px);
    }
    to {
        opacity: 1;
        transform: translate(-50%, 0);
    }
}
</style> 